import { Input } from "antd";
import classNames from "classnames";
import { useEffect, useState } from "react";

import styles from "./InputWithCopy.module.scss";

export const InputWithCopy = ({ initialValue = "", disableEditing = false, loading = false }) => {
    const [value, setTabValue] = useState(initialValue); 
    const [isCopied, setIsCopied] = useState(false);

    useEffect(() => {
        setTabValue(initialValue);
    }, [initialValue]);

    const handleCopy = () => {
        if (loading) return;
        navigator.clipboard.writeText(value);
        setIsCopied(true);
        setTimeout(() => setIsCopied(false), 2000);
    };

    return (
        <Input
            value={loading ? "" : value}
            placeholder="Fetching..."
            className={classNames(styles.root)}
            onChange={(e) => !disableEditing && setTabValue(e.target.value)}
            suffix={
                <div className={styles.copy} onClick={handleCopy}>
                {isCopied ? "Copied!" : "Copy"}
                </div>
            }
            variant="outlined"
        />
    );
}
